export default __webpack_public_path__ + "static/liveTag-1ff12b37c33251be0325d92585ec421c.png";